import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Preloader from "@/components/Preloader";
import Layout from "@/components/Layout";
import LoginPage from "@/pages/auth/LoginPage";
import ProtectedRoute from "@/components/admin/ProtectedRoute";
import AdminLayout from "@/components/admin/AdminLayout";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import AdminListPage from "@/pages/admin/AdminListPage";
import AdminEditorPage from "@/pages/admin/AdminEditorPage";
import AdminMessagesPage from "@/pages/admin/AdminMessagesPage";
import AdminChangePasswordPage from "@/pages/admin/AdminChangePasswordPage";
import AdminSiteSettingsPage from "@/pages/admin/AdminSiteSettingsPage";
import HomePage from "@/pages/HomePage";
import AboutPage from "@/pages/AboutPage";
import NewsListPage from "@/pages/NewsListPage";
import NewsDetailPage from "@/pages/NewsDetailPage";
import ArticlesListPage from "@/pages/ArticlesListPage";
import ArticleDetailPage from "@/pages/ArticleDetailPage";
import MagazinePage from "@/pages/MagazinePage";
import InterviewsListPage from "@/pages/InterviewsListPage";
import InterviewDetailPage from "@/pages/InterviewDetailPage";
import GetFeaturedPage from "@/pages/GetFeaturedPage";
import ContactPage from "@/pages/ContactPage";
import NotFoundPage from "@/pages/NotFoundPage";

function AppRouter() {
  return (
    <Routes>
      {/* Admin login (public URL, gated by credentials) */}
      <Route path="/admin/login" element={<LoginPage />} />
      {/* Legacy /login route redirects to new admin login */}
      <Route path="/login" element={<Navigate to="/admin/login" replace />} />

      {/* Admin routes (protected) */}
      <Route
        path="/admin"
        element={
          <ProtectedRoute>
            <AdminLayout />
          </ProtectedRoute>
        }
      >
        <Route index element={<AdminDashboard />} />
        <Route path="site-settings" element={<AdminSiteSettingsPage />} />
        <Route path="change-password" element={<AdminChangePasswordPage />} />
        <Route path="messages/:msgKind" element={<AdminMessagesPage />} />
        <Route path=":kind" element={<AdminListPage />} />
        <Route path=":kind/new" element={<AdminEditorPage />} />
        <Route path=":kind/edit/:id" element={<AdminEditorPage />} />
      </Route>

      {/* Public routes */}
      <Route
        path="/*"
        element={
          <>
            <Preloader />
            <div className="paper-grain" aria-hidden="true" />
            <Layout>
              <Routes>
                <Route path="/" element={<HomePage />} />
                <Route path="/about" element={<AboutPage />} />
                <Route path="/news" element={<NewsListPage />} />
                <Route path="/news/:slug" element={<NewsDetailPage />} />
                <Route path="/articles" element={<ArticlesListPage />} />
                <Route path="/articles/:slug" element={<ArticleDetailPage />} />
                <Route path="/magazine" element={<MagazinePage />} />
                <Route path="/interviews" element={<InterviewsListPage />} />
                <Route path="/interviews/:slug" element={<InterviewDetailPage />} />
                <Route path="/get-featured" element={<GetFeaturedPage />} />
                <Route path="/contact" element={<ContactPage />} />
                <Route path="*" element={<NotFoundPage />} />
              </Routes>
            </Layout>
          </>
        }
      />
    </Routes>
  );
}

function App() {
  return (
    <div className="App bg-paper text-ink">
      <BrowserRouter>
        <AppRouter />
      </BrowserRouter>
      <Toaster position="bottom-right" theme="light" />
    </div>
  );
}

export default App;
